module.exports = __webpack_public_path__ + "img/changepass.2a408f12.svg";